import { useCallback } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { config } from 'app/config';
import { addBenefit, updateBenefit } from 'services/benefit-type-service';
import { Button, themes, Popup2 } from 'libs/ui';
import { required, maxTenMillionValue, checkFn, WhiteStyledField, Title, ErrorMsg } from 'libs/form';
import { StyledButtonContainer } from './benefit-type-form.styled';

const BenefitTypeForm = (props) => {
  const { error, destroy, refresh, setMessage, form, handleSubmit, close, type } = props;

  const { t } = useTranslation();
  const isAdd = type === 'addForm';
  const requiredT = useCallback(required(t), [t]);
  const maxTenMillionValueT = useCallback(maxTenMillionValue(t), [t]);
  const checkFnT = useCallback(checkFn(t), [t]);

  /**
   * after submit
   */
  const afterSubmit = () => {
    refresh();
    setMessage(isAdd ? t('messages.Сохранено успешно') : t('messages.Изменения сохранены'));
    setTimeout(() => {
      setMessage('');
    }, 3000);
    close();
    destroy(form);
  };

  /**
   * submit
   * @param {*} values
   * @returns
   */
  const submit = (values) => {
    // data
    const out = { ...values };
    const method = isAdd ? addBenefit : updateBenefit;

    return method(out)
      .then(() => {
        afterSubmit();
        return true;
      })
      .catch((error) => {
        console.log('🚀 ~ submit ~ error:', error);
        // notify('Скидки', error.toString());
        if (error?.type === 'duplicate') {
          throw new SubmissionError({
            _error: t('errors.Скидка с такими параметрами уже существует'),
          });
        }
      });
  };

  const cancel = () => {
    close();
    destroy(form);
  };

  const title = isAdd ? t('form.Новая скидка') : t('form.Скидка') + ' ' + props.initialValues?.name;

  return (
    <Popup2 w={482}>
      <Title>{title}</Title>
      <form onSubmit={handleSubmit(submit)}>
        <ErrorMsg message={error} />

        <WhiteStyledField validate={requiredT} placeholder={t('form.Клиент')} type="text" label={t('form.Клиент') + config.req} name="name" autoFocus />
        <WhiteStyledField
          validate={checkFnT}
          placeholder={t('form.Номер ФН')}
          type="text"
          label={t('form.Номер ФН') + config.req}
          name="fn"
          maxLength={16}
          withoutSpaces
          withoutLetters
        />
        <WhiteStyledField
          validate={[requiredT, maxTenMillionValueT]}
          placeholder={t('grid.Минимальная сумма')}
          type="text"
          label={t('grid.Минимальная сумма') + config.req}
          name="min_amount"
          naturalNumber
        />
        <WhiteStyledField
          validate={[requiredT, maxTenMillionValueT]}
          placeholder={t('grid.Сумма скидки')}
          type="text"
          label={t('grid.Сумма скидки') + config.req}
          name="amount"
          naturalNumber
        />

        <StyledButtonContainer space="20px">
          <Button type="button" onClick={cancel}>
            {t('buttons.Отменить')}
          </Button>
          <Button theme={themes.blue} type="submit">
            <i className="fa fa-save" />
            {t('buttons.Сохранить')}
          </Button>
        </StyledButtonContainer>
      </form>
    </Popup2>
  );
};

export default reduxForm({
  form: 'benefitTypeForm',
  // destroyOnUnmount: false,
})(BenefitTypeForm);
